import { scheduleTask } from 'ember-lifeline';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export function scrollRhsToTop(context): void {
  scheduleTask(context, 'render', () => {
    window.document
      .getElementById('rhs')
      ?.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

// Loads AI settings only for users who can access AI messaging. The
// `/v2/ai_settings` endpoint is authorized against `ai_drafts.create`, which is
// not grantable to owners/restricted teammates, so fetching it for them returns
// a 403 that the application adapter turns into a redirect away from the page.
// Mirroring that permission here keeps the request to users who actually use it.
export function loadAiSettingsIfPermitted(context): Promise<unknown> {
  const canAccess =
    !!context.session?.currentUser?.hasAccessTo('ai_drafts.create');

  return canAccess ? context.store.findAll('ai-setting') : Promise.resolve([]);
}

export async function markInboxMessageRead(
  context,
  inboxMessage?: ModelRegistry['inbox-message'],
): Promise<void> {
  if (!inboxMessage?.unread) {
    return;
  }

  inboxMessage.unread = false;

  try {
    await inboxMessage.save();
  } catch (err) {
    inboxMessage.unread = true;
    context.sentry.captureException(err);

    return;
  }

  try {
    await context.currentUser.reload();
  } catch (err) {
    context.sentry.captureException(err);
  }
}
